import styled from 'styled-components';

export const TableWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
  flex-wrap: wrap;
  gap: 1rem;
`;

export const Title = styled.h2`
  margin: 0;
  font-size: 1.5rem;
  font-weight: 700;
  color: var(--text-main-color);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
